module.exports = new __parcel__URL__("jpd-logo.c2926e56.svg").toString();